import { registerComponent } from '../app'
import { DESELECT_SS_CATEGORY } from '../events'

const SSDeselect = (scope, el) => {
	el.addEventListener('click', e => {
		scope.emit(DESELECT_SS_CATEGORY)
	})
}

registerComponent('ss-deselect', SSDeselect)
